/*
 * Access page tabs: which tabs the console shows, which one the URL asks for and which one the viewer gets, and the
 * header line of each (pure; the route reads `?tab=` and the router validates it against `ACCESS_TABS`).
 */
export type AccessTab = 'members' | 'tokens' | 'ci';
export const ACCESS_TABS: readonly AccessTab[] = ['members', 'tokens', 'ci'];

/**
 * The tabs the MVP renders: Members only. API tokens (personal and service) and CI trust (OIDC) return with CLI and CI
 * builds, docs/mvp-plan.md P17 (add them back here, after Members).
 */
export const VISIBLE_ACCESS_TABS: readonly AccessTab[] = ['members'];

/** The tab for `?tab=`: a visible one as requested, else the first visible tab (Members). */
export function resolveAccessTab(requested: string | undefined, visible: readonly AccessTab[] = VISIBLE_ACCESS_TABS): AccessTab {
  const tab = visible.find((t) => t === requested);
  return tab ?? visible[0] ?? 'members';
}

/** The `?tab=` value that selects `next` (the default tab, Members, keeps the URL clean). */
export const tabSearchValue = (next: string): string | undefined => (next === 'members' ? undefined : next);

/** The header line under "Access", for the tab on screen. */
export const ACCESS_TAB_INTRO: Record<AccessTab, string> = {
  members: 'Invite people to your organization, choose what each one may do, and remove access when they leave.',
  tokens: 'Tokens let the hangar CLI and your scripts call Hangar as you. Pipelines use CI trust instead of stored tokens.',
  ci: 'Pipelines exchange their OIDC token through a trust policy instead of a stored token.',
};
